module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-1000-Inactive-Rumble-c28fa164619e624de85924979512f7b5.png";